import React, { useState } from 'react';
import styles from './cubonetattoo.module.scss';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';

const Perfil = require('./src/perfil.png');
const InstagramTay = require('./src/instagram-tay.png');
const InstagramCubone = require('./src/instagram-cubone.png');

const Cubonetattoo: React.FC = () => {
    const [showInstagrams, setShowInstagrams] = useState(false);

    return (
        <div className={styles.cubonetattoo}>
            <div className={styles["body-thunder"]}>
                <div className={styles["container-thunder"]}>
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            topLeft={true}
                            linkInterno={true}
                            href="/cubonetattoo/sobremim"
                            title="SOBRE"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            topRight={true}
                            linkInterno={true}
                            href="/cubonetattoo/galeria"
                            title="GALERIA"
                            icon={<TattooIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517997449691?text=Olá, vim pelo link na bio..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <div className={styles.link} onClick={() => setShowInstagrams(true)}>
                            <LinkPersonalizado7
                                noLink
                                href=""
                                title="INSTAGRAM"
                                icon={<InstagramIcon height="32" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {showInstagrams && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowInstagrams(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowInstagrams(false)}
                        >
                            ✕
                        </button>
                        <h2>Instagram</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <img src={InstagramCubone} alt="Rafael Carvalho" />
                                <h3>Rafael Carvalho</h3>
                                <p>@cubonetattoo</p>
                                <a
                                    href="https://www.instagram.com/cubonetattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <img src={InstagramTay} alt="Tayná Frasson" />
                                <h3>Tayná Frasson</h3>
                                <p>@tayfrasson.tattoo</p>
                                <a
                                    href="https://www.instagram.com/tayfrasson.tattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cubonetattoo;
